var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngellist({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.93584 10.5312L7.39618 2.95879C7.04584 1.1413 9.18261 0.29827 10.0039 1.79497L13.3351 9.95084M9.93584 10.5312C9.80741 14.5849 15.5468 13.8763 16.849 13.7474C11.372 15.3858 12.0423 18.9019 12.4636 20.7428M9.93584 10.5312C10.7814 9.47151 12.0745 9.84295 13.3351 9.95084M13.3351 9.95084L16.9991 2.09357C17.7453 0.729738 19.8385 1.80481 19.3504 3.1797L16.9449 10.5995M13.3351 9.95084C14.7686 10.0752 16.1535 10.3735 16.9449 10.5995M16.9449 10.5995C18.3969 10.8563 19.3504 12.1383 19.6743 13.3372C21.2051 27.2122 1.38725 23.7837 4.59262 15.4962C5.30309 13.6593 6.79496 14.4285 7.33126 14.6708M7.33126 14.6708C8.25949 15.4707 9.1236 16.8048 9.57493 17.6869M7.33126 14.6708C5.33952 12.2931 6.68622 9.83498 8.78669 10.7651C10.4911 11.5199 12.1381 16.0117 12.1572 16.3247C12.1764 16.6376 12.0484 18.8835 9.57493 17.6869M9.57493 17.6869C10.6442 20.5771 7.33127 20.4667 5.79913 17.2083",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngellist);
export default __webpack_public_path__ + "static/media/angellist.9884bfdd99caae4977c88de6fae3d089.svg";
export { ForwardRef as ReactComponent };